import React from 'react';
import ContractorContactDataTable from "./ContractorContactDataTable";

const ContractorContact = () => {
    return (<ContractorContactDataTable/>);
};

export default ContractorContact;